type PostHogClient = typeof import('posthog-js').default;

let postHogClientPromise: Promise<PostHogClient> | null = null;
let initialized = false;

export const isPostHogEnabled = () => {
  return Boolean(import.meta.env.VITE_POSTHOG_API_KEY) && import.meta.env.MODE !== 'development';
};

const loadPostHogClient = async () => {
  if (!isPostHogEnabled()) return null;

  try {
    postHogClientPromise ??= import('posthog-js').then((module) => module.default);
    return await postHogClientPromise;
  } catch {
    postHogClientPromise = null;
    return null;
  }
};

export const initializePostHog = async (userEmail?: string) => {
  const posthog = await loadPostHogClient();
  if (!posthog) return;

  if (!initialized) {
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: 'https://app.posthog.com',
      autocapture: true,
    });
    initialized = true;
  }

  if (userEmail) {
    posthog.identify(userEmail, { email: userEmail });
  }
};

export const resetPostHog = async () => {
  if (!postHogClientPromise) return;

  const posthog = await loadPostHogClient();
  posthog?.reset();
  initialized = false;
};
